<template>
  <div class="flex flex-row items-center justify-center w-full gap-0">
    <button @click.stop="decrement">
      <FontAwesomeIcon icon="minus" />
    </button>
    <input type="number" :min="min" :max="max" :value="value" @change="handleChange" />
    <button @click.stop="increment">
      <FontAwesomeIcon icon="plus" />
    </button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  min: {
    type: Number,
    default: 0,
    required: false,
  },
  max: {
    type: Number,
    default: Number.MAX_SAFE_INTEGER,
    required: false,
  },
  size: {
    type: Number,
    default: 2,
  },
  step: {
    type: Number,
    default: 1,
  },
})

const emit = defineEmits(['input'])

function clamp(value: number) {
  const { min, max } = props

  if (value < min) {
    return min
  } else if (value > max) {
    return max
  }

  return value
}

function handleChange(event: Event) {
  const target = event.target as HTMLInputElement
  emit('input', +target.value)
}

function increment() {
  emit('input', clamp(props.value + props.step))
}

function decrement() {
  emit('input', clamp(props.value - props.step))
}
</script>

<style lang="stylus" scoped>
input
  @apply flex items-center text-center bg-white text-gray-750 pl-2 pr-2 text-xs focus_outline-none flex-grow w-0 h-full
  appearance: textfield
  -moz-appearance: textfield
  -webkit-appearance: textfield

  &::-webkit-inner-spin-button, &::-webkit-outer-spin-button
    @apply appearance-none

button
  @apply flex w-6 h-full leading-none items-center text-xs text-gray-800 bg-gray-300 items-center justify-center

button:first-child
  @apply rounded-l-md
button:last-child
  @apply rounded-r-md
</style>
